/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Lifts_EmptyInputs */

const en_us2_progress_lifts_empty = /** @type {(inputs: Progress_Lifts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No loaded exercise in these weeks.`)
};

const pt_br2_progress_lifts_empty = /** @type {(inputs: Progress_Lifts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum exercício com carga nestas semanas.`)
};

const es_419_progress_lifts_empty = /** @type {(inputs: Progress_Lifts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún ejercicio con peso en estas semanas.`)
};

const pt_pt2_progress_lifts_empty = /** @type {(inputs: Progress_Lifts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum exercício com carga nestas semanas.`)
};

const fr_fr2_progress_lifts_empty = /** @type {(inputs: Progress_Lifts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun exercice avec charge sur ces semaines.`)
};

const de_de2_progress_lifts_empty = /** @type {(inputs: Progress_Lifts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Übung mit Gewicht in diesen Wochen.`)
};

const it_it2_progress_lifts_empty = /** @type {(inputs: Progress_Lifts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun esercizio con carico in queste settimane.`)
};

/**
* | output |
* | --- |
* | "No loaded exercise in these weeks." |
*
* @param {Progress_Lifts_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_lifts_empty = /** @type {((inputs?: Progress_Lifts_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Lifts_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_lifts_empty(inputs)
	if (locale === "es-419") return es_419_progress_lifts_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_lifts_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_lifts_empty(inputs)
	if (locale === "de-DE") return de_de2_progress_lifts_empty(inputs)
	if (locale === "it-IT") return it_it2_progress_lifts_empty(inputs)
	return en_us2_progress_lifts_empty(inputs)
});
export { progress_lifts_empty as "progress.lifts_empty" }